import ModernDrawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';

export const Drawer = ModernDrawer;
